import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import {
  Box,
  List,
  ListItem,
  HStack,
  Text,
  Skeleton,
  IconButton,
} from "@chakra-ui/react";
import Button from "components/Button/Button";

import useCopy from "hooks/useCopy";
import { isObject } from "lodash";

import chunk from "lodash/chunk";
import { useState } from "react";

const makeSpacesInFour = (value) =>
  chunk(value, 4)
    .map((v) => v.join(""))
    .join(" ");

const CardDetailItem = ({
  isCardNumber,
  canBeHidden,
  title,
  description,
  isLoading,
}) => {
  const { onCopy } = useCopy(description ?? "");

  const [isHidden, setIsHidden] = useState(true);

  const toggleHidden = () => setIsHidden(!isHidden);

  return (
    <ListItem
      p="20px 0"
      borderBottom={
        //   i !== items.length - 1 ? "1px solid #D9DBE9" : "none"
        "1px solid #D9DBE9"
      }
    >
      <HStack justifyContent="space-between">
        <HStack pos="relative">
          <Box>
            <Skeleton isLoaded={!isLoading}>
              <Text fontSize="xs">{title}</Text>
            </Skeleton>
            <Skeleton mt={isLoading ? "6px" : "0"} isLoaded={!isLoading}>
              <Text fontSize="sm">
                {isCardNumber
                  ? makeSpacesInFour(description)
                  : canBeHidden && isHidden
                  ? "*".repeat(description?.length ?? 4)
                  : description}
              </Text>
            </Skeleton>
          </Box>

          {canBeHidden && (
            <IconButton
              pos="absolute"
              variant="ghost"
              size="xs"
              aria-label="pin visibility button"
              icon={
                isHidden ? (
                  <ViewIcon fontSize="xs" />
                ) : (
                  <ViewOffIcon fontSize="xs" />
                )
              }
              onClick={toggleHidden}
              bottom="-1px"
              right="-32px"
              _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
            />
          )}
        </HStack>

        <Skeleton isLoaded={!isLoading}>
          <Button
            size="sm"
            variant="ghost"
            color="var(--primary)"
            bg="transparent"
            minW="fit-content"
            onClick={onCopy}
          >
            Copy
          </Button>
        </Skeleton>
      </HStack>
    </ListItem>
  );
};

const MyCardDetails = ({ isLoading, details, provider }) => {
  console.log("DEATAILS", details);

  let items = [
    {
      title: "Card name",
      // description: details?.cardName,
      description: details?.nameOnCard,
      isCardNumber: false,
    },
    {
      title: "Card number",
      description: details?.cardNumber,
      isCardNumber: true,
    },
    {
      title: "CVV",
      description: details?.cvv2,
      isCardNumber: false,
    },
    {
      title: "Pin",
      description: details?.pin,
      isCardNumber: false,
      canBeHidden: true,
    },
    {
      title: "Card Validity",
      // description: details?.valid,
      description: isObject(details?.address)
        ? details?.expiry
        : details?.valid,
      isCardNumber: false,
    },
    {
      title: "Country",
      description: details?.address?.country,
      isCardNumber: false,
    },
    {
      title: "Postal Code",
      // description: details?.address,
      description: isObject(details?.address)
        ? details?.address?.postal_code
        : details?.postalCode,
      isCardNumber: false,
    },
    {
      title: "Address",
      // description: details?.address,
      description: isObject(details?.address)
        ? details?.address?.street
        : details?.address,
      isCardNumber: false,
    },
    // {
    //   title: "City",
    //   description: details?.city,
    //   isCardNumber: false,
    // },
    {
      title: "State",
      // description: details?.state,
      description: isObject(details?.address)
        ? details?.address?.state
        : details?.state,
      isCardNumber: false,
    },
    {
      title: "City",
      // description: details?.state,
      description: isObject(details?.address)
        ? details?.address?.city
        : details?.city,
      isCardNumber: false,
    },
  ];

  // if((provider ?? "") === 'p1') {
  //   items = [
  //     {
  //       title: "Card name",
  //       description: details?.cardName,
  //       isCardNumber: false,
  //     },
  //   ];
  // }

  return (
    <Box>
      <List>
        {items.map(
          (item, i) =>
            !!item?.description &&
            !String(item?.description)?.includes("undefined") && (
              <CardDetailItem
                key={`card-detail-${i}`}
                {...item}
                isLoading={isLoading}
              />
            )
        )}

        <ListItem p="20px 0">
          <HStack justifyContent="space-between">
            <Box>
              <Skeleton isLoaded={!isLoading}>
                <Text fontSize="xs">Card status</Text>
              </Skeleton>
              <Skeleton mt={isLoading ? "6px" : "0"} isLoaded={!isLoading}>
                <Text
                  fontSize="sm"
                  color={!!!details?.frozen ? "var(--primary)" : "#f56565"}
                >
                  Active
                </Text>
              </Skeleton>
            </Box>
          </HStack>
        </ListItem>
      </List>
    </Box>
  );
};

export default MyCardDetails;
